import $ from "jquery";
import { log } from "spritespin/release/src/utils";

class ProductFilter {
	constructor() {
		this.init();
	}

    init() {
        this.dom();
        this.events();

        //this.getUrlParameters();
        //this.initialFilters();
    }

    dom() {
        this.$body = $('body');

        this.$window = $(window);

        this.$filterWrap = this.$body.find('.filter-wrap')

        this.$filterGroups = this.$filterWrap.find('.filter-group');

        this.$fillterContent = this.$filterGroups.find('.filter-content')

        this.$inputs = this.$fillterContent.find('input[type=checkbox], input[type=radio]');

        this.$filterInputs = this.$inputs.next('.cbr-helper');

        this.$filterRangeInputs = this.$filterGroups.find('[data-slider]');

        this.$clearFiltersButton = $('.clear-filter');

        this.$filterResultWrap = $('.filter-result');

        this.throttled = false;

        this.filterCategoryId = this.$filterWrap.data('filter-category');

        this.filterAttrribute = this.$filterWrap.data('filter-attribute');
    }

    events() {
        this.$window.off('load.ProductFilter');
        this.$window.on('load.ProductFilter', this.initialFilters.bind(this));

        this.$filterInputs.off('click.ProductFilter');
        this.$filterInputs.on('click.ProductFilter', this.showFilteredProducts.bind(this));

        this.$filterRangeInputs.on('change.fndtn.slider, moved.zf.slider', this.enableRangeFilter.bind(this));

        this.$clearFiltersButton.on('click.ProductFilter', this.clearFilter.bind(this));
    }

    enableRangeFilter(event) {
        if(this.throttled === false) {
            const $currentRangeFilter = $(event.currentTarget);
            $currentRangeFilter.addClass('active');

            this.showFilteredProducts();

            this.throttled = true;
            setTimeout(() => {
                this.throttled = false;
            }, 100);
        }
    }

    showFilteredProducts() {
        this.currentUrl = window.location.origin + window.location.pathname;
        this.getFilters();
        this.addFilterParams();
        this.filterResult();
    }

    getFilters() {
        this.filters = [];

        this.$filterGroups.each( (i) => {
            const $currentFilter = this.$filterGroups.eq(i);
            const taxonomyName = $currentFilter.data("filter-name");
            this.$checkedFilters = $currentFilter.find('.filter-content input:checked');
            this.$rangeFilters = $currentFilter.find('[data-slider]');
            var taxonomyData = [];
            var choice = '';

            if(this.$checkedFilters.length > 0) {
                this.$checkedFilters.each((i) => {
                    const currentFilterValue = this.$checkedFilters.eq(i).val();
                    taxonomyData.push(currentFilterValue);
                    choice = 'checkbox';
                })
            }

            if(this.$rangeFilters.length > 0 && this.$rangeFilters.hasClass('active')) {
                this.$rangeFilters.each((i) => {
                    var minValue = this.$rangeFilters.eq(i).find('.input.min input').val()
                    var maxValue = this.$rangeFilters.eq(i).find('.input.max input').val()
                    choice = 'slider';
                    taxonomyData.push(minValue);
                    taxonomyData.push(maxValue);
                })
            }
        
            if (taxonomyData.length > 0) {
                this.filters.push({ taxonomy: { name: taxonomyName, data: taxonomyData, choice: choice} });
            }
        });
    }

    addFilterParams() {
        var paramsList = [];
        if(this.filters.length > 0) {
            $.each(this.filters, (filter) => {
                var taxonomyName = this.filters[filter].taxonomy.name;
                var taxonomyData = this.filters[filter].taxonomy.data;
                paramsList[taxonomyName] = taxonomyData;
            });
            this.updateUrlParams(paramsList);
        } else {
            window.history.pushState('', '', this.currentUrl);
        }
    }

    updateUrlParams (paramsList) {
        var urlParamsString = "?";

        for (var item in paramsList) {
            if (paramsList.hasOwnProperty(item)) {
                urlParamsString += item + "=" + paramsList[item] + "&";
            }
        }

        urlParamsString = urlParamsString.replace(/&$/, "");

        var newurl = this.currentUrl + urlParamsString;
        window.history.pushState(urlParamsString, '', newurl);
    }

    filterResult() {
        $.ajax({
            type: "post",
            url: "/wp-admin/admin-ajax.php",
            data: {
                action: 'robust_product_filter',
                slugs: JSON.stringify(this.filters),
                categoryId: JSON.stringify(this.filterCategoryId),
                attribute: JSON.stringify(this.filterAttrribute)
            },
            beforeSend: () => {
                this.$filterResultWrap.hide();
                this.$filterWrap.addClass('loading');
            },
            success: (data) => {
                this.$filterWrap.removeClass('loading');
                this.$filterResultWrap.html(data);
                this.$filterResultWrap.show();
            },
            error: () => {
                this.$filterWrap.removeClass('loading');
                alert("error");
            }
        });
    }

    getUrlParams() {
        const urlParams = new URLSearchParams(window.location.search);
        const urlParamsString = decodeURIComponent(urlParams);
        const params = urlParamsString.split('&')
        var paramsList = [];

        $.each(params, (i) => {
            var name = params[i].split('=')[0];
            var values = params[i].split('=')[1];

            paramsList[name] = values;
        });

        return paramsList;
    }

    initialFilters() {
        let paramsList = [];

        if(this.$filterGroups.length > 0) {
            paramsList = this.getUrlParams();

            this.$filterGroups.each((i) => {
                const $currentFilter = this.$filterGroups.eq(i);
                const taxonomyName = $currentFilter.data("filter-name");

                if(paramsList[taxonomyName]) {
                    const params = paramsList[taxonomyName].split(',');

                    if($currentFilter.hasClass('filter-range')) {
                       this.setRangeFilter($currentFilter, params[0], params[1]);
                    } else {
                        $.each(params, (i) => {
                            const $currentFilterInputs = $currentFilter.find('input');
    
                            $currentFilterInputs.each((j) => {
                                const inputValue = $currentFilterInputs.eq(j).val();
    
                                if(inputValue == params[i]) {
                                    $currentFilterInputs.eq(j).prop("checked", true);
                                }
                            })
                        });
                    }
                }
            })
        }

        //this.showFilteredProducts();
    }

    clearFilter(event) {
        const $currentClearBtn = $(event.currentTarget);
        const $filter = $currentClearBtn.closest('.filter');

        const $clearGroupFilters = $currentClearBtn.next('.filters').find('.clear-filter');

        if($clearGroupFilters.length > 0) {
            $clearGroupFilters.each((i) => {
                const $currentClearFilterBtn = $clearGroupFilters.eq(i);
                $currentClearFilterBtn.trigger('click');
            });
            return;
        }

        $filter.find(".filter-content input").prop("checked", false);

        if($filter.find('.filter-range-slider').length > 0) {
            this.resetRangeFilter($filter);
        }

        this.showFilteredProducts()
    }

    resetRangeFilter($filter) {
        var slider = $filter.find('[data-slider]');

        var minValue = parseFloat(slider.attr('data-start'));
        var maxValue = parseFloat(slider.attr('data-end'));

        var handles = slider.find('.slider-handle');
        var inputs = slider.find('.filter-inputs input');
      
        handles.eq(0).attr('aria-valuenow', minValue);
        handles.eq(1).attr('aria-valuenow', maxValue);
        inputs.eq(0).val(minValue);
        inputs.eq(1).val(maxValue);

        var fill = slider.find('.slider-fill');

        var startHandle = handles.eq(0);
        var endHandle = handles.eq(1);

        fill.attr('style', 'width:0px; min-width:99.15%; left:0%;')

        startHandle.attr('style', 'left:0%;')
        endHandle.attr('style', 'left:99.15%;')

        slider.removeClass('active');
    }

    setRangeFilter($filter, min, max) {
        var slider = $filter.find('[data-slider]');
        slider.addClass('active');

        var minValue = parseFloat(slider.attr('data-start'));
        var maxValue = parseFloat(slider.attr('data-end'));

        var handles = slider.find('.slider-handle');
        var inputs = slider.find('.filter-inputs input');
      
        handles.eq(0).attr('aria-valuenow', min);
        handles.eq(1).attr('aria-valuenow', max);
        inputs.eq(0).val(min);
        inputs.eq(1).val(max);

        var fill = slider.find('.slider-fill');

        var startHandle = handles.eq(0);
        var endHandle = handles.eq(1);

        var minWidthFill = 99.15 - (min * 99.15 / maxValue) - (99.15 - (max * 99.15 / maxValue));
        var leftFill = min * 99.15 / maxValue;
        var leftStartHandle = leftFill;
        var leftEndHandle = max * 99.15 / maxValue;


        fill.attr('style', 'width:0px; min-width:' + minWidthFill.toFixed(2) + '%; left:' + leftFill.toFixed(2) + '%;')

        startHandle.attr('style', 'left:' + leftStartHandle.toFixed(2) + '%;')
        endHandle.attr('style', 'left:' + leftEndHandle.toFixed(2) + '%;')
    }
}

export default ProductFilter;